import { call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import * as types from '../constants/actionTypes';
import * as actions from '../actions/returnOrderActions';
import { returnsAPI, creditNotesAPI } from '../../api/config';

function* createReturnOrderSaga(action) {
  try {
    const response = yield call(returnsAPI.create, action.payload);
    yield put(actions.createReturnOrderSuccess(response.data));
    message.success(`Return order ${response.data.return_order_number} created`);
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to create return order';
    yield put(actions.createReturnOrderFailure(msg));
    message.error(msg);
  }
}

function* fetchReturnOrdersSaga(action) {
  try {
    const response = yield call(returnsAPI.list, action.payload);
    yield put(actions.fetchReturnOrdersSuccess(response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch return orders';
    yield put(actions.fetchReturnOrdersFailure(msg));
    message.error(msg);
  }
}

function* fetchReturnOrderSaga(action) {
  try {
    const response = yield call(returnsAPI.get, action.payload);
    yield put(actions.fetchReturnOrderSuccess(response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch return order';
    yield put(actions.fetchReturnOrderFailure(msg));
  }
}

function* approveReturnOrderSaga(action) {
  try {
    const response = yield call(returnsAPI.approve, action.payload);
    yield put(actions.approveReturnOrderSuccess(response.data));
    message.success('Return order approved');
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to approve return order';
    yield put(actions.approveReturnOrderFailure(msg));
    message.error(msg);
  }
}

function* updateReturnOrderStatusSaga(action) {
  try {
    const { id, status } = action.payload;
    const response = yield call(returnsAPI.updateStatus, id, { status });
    yield put(actions.updateReturnOrderStatusSuccess(response.data));
    message.success(`Return order status updated to ${status}`);
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to update status';
    yield put(actions.updateReturnOrderStatusFailure(msg));
    message.error(msg);
  }
}

function* createCreditNoteSaga(action) {
  try {
    const response = yield call(creditNotesAPI.create, action.payload);
    yield put(actions.createCreditNoteSuccess(response.data));
    message.success(`Credit note ${response.data.credit_note_number} recorded`);
    // Refresh return orders to pick up the status change
    yield put(actions.fetchReturnOrdersRequest({}));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to create credit note';
    yield put(actions.createCreditNoteFailure(msg));
    message.error(msg);
  }
}

function* fetchCreditNotesSaga(action) {
  try {
    const response = yield call(creditNotesAPI.list, action.payload);
    yield put(actions.fetchCreditNotesSuccess(response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch credit notes';
    yield put(actions.fetchCreditNotesFailure(msg));
    message.error(msg);
  }
}

function* fetchCreditNoteSaga(action) {
  try {
    const response = yield call(creditNotesAPI.get, action.payload);
    yield put(actions.fetchCreditNoteSuccess(response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch credit note';
    yield put(actions.fetchCreditNoteFailure(msg));
  }
}

function* adjustCreditNoteSaga(action) {
  try {
    const { id, billReceiptId } = action.payload;
    const response = yield call(creditNotesAPI.adjust, id, { bill_receipt_id: billReceiptId });
    yield put(actions.adjustCreditNoteSuccess(response.data));
    message.success('Credit note adjusted against bill successfully');
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to adjust credit note';
    yield put(actions.adjustCreditNoteFailure(msg));
    message.error(msg);
  }
}

export default function* returnOrderSaga() {
  yield takeLatest(types.CREATE_RETURN_ORDER_REQUEST, createReturnOrderSaga);
  yield takeLatest(types.FETCH_RETURN_ORDERS_REQUEST, fetchReturnOrdersSaga);
  yield takeLatest(types.FETCH_RETURN_ORDER_REQUEST, fetchReturnOrderSaga);
  yield takeLatest(types.APPROVE_RETURN_ORDER_REQUEST, approveReturnOrderSaga);
  yield takeLatest(types.UPDATE_RETURN_ORDER_STATUS_REQUEST, updateReturnOrderStatusSaga);
  yield takeLatest(types.CREATE_CREDIT_NOTE_REQUEST, createCreditNoteSaga);
  yield takeLatest(types.FETCH_CREDIT_NOTES_REQUEST, fetchCreditNotesSaga);
  yield takeLatest(types.FETCH_CREDIT_NOTE_REQUEST, fetchCreditNoteSaga);
  yield takeLatest(types.ADJUST_CREDIT_NOTE_REQUEST, adjustCreditNoteSaga);
}
